export default __webpack_public_path__ + "static/media/66.ded372a4.jpg";